<template>
    <div class="p-col-12">
        <page-header title="dataTable.contract.title" :actions="pageActions"/>
        <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
    </div>
</template>

<script>
    import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
    import FrontBusiness from "@/business/FrontBusiness";
    import PageHeader from "@/components/page/PageHeader";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import DialogService from "@/business/ModalBusiness";
    import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
    import ContractBusiness from "@/business/ContractBusiness";

    export default {
        name: "ContractList",
        components: {PageHeader, AncestrylineDataTable},

        data() {
            return {
                dataFunction: ContractBusiness.pagination,
                columns: [
                    {field: "name", header: 'dataTable.contract.columns.name', sortable:true},
                    {field: "installmentsGroupName", header: 'dataTable.contract.columns.fragmentGroup', sortable:true},
                    {field: "created", header: 'dataTable.contract.columns.created', sortable:true, type: 'date-time'},
                    {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
                        actions: [
                          {icon: 'pi pi-pencil', title: 'dataTable.contract.columns.edit', function: this.editContract},
                          {icon: 'pi pi-trash', title: 'dataTable.contract.columns.delete', function: this.deleteContract, refreshList: true},
                        ]
                    },
                ],
                pageActions: [
                    {icon: 'pi pi-tag', label: 'dataTable.contract.add', url: '/contract'},
                    {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
                ],
            }
        },

        methods: {

          editContract(contract){
              FrontBusiness.redirect(`/contract/${contract.id}`);
          },

          async deleteContract(contract, dataList){
            if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
              const response = await ContractBusiness.delete(contract.id).catch((e) => {
                if(e.contract_constraint){
                  ToastMessageBusiness.showError(e.contract_constraint)
                } else {
                  ToastMessageBusiness.showError(e.message)
                }
              });
              if(response){
                dataList = dataList.filter(c => c.id !== contract.id);
                ToastMessageBusiness.showSuccess();
              }
              return dataList;
            }
          },

          openModal(){
              //DialogService.openModal(Audit, {business: ContractBusiness});
          },

        }

    }
</script>

<style scoped>

</style>
